var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_3332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 3.80001C2.4 2.95131 2.73714 2.13738 3.33726 1.53726C3.93737 0.937148 4.75131 0.600006 5.6 0.600006C6.44869 0.600006 7.26263 0.937148 7.86274 1.53726C8.46286 2.13738 8.8 2.95131 8.8 3.80001C8.8 4.6487 8.46286 5.46263 7.86274 6.06275C7.26263 6.66286 6.44869 7.00001 5.6 7.00001C4.75131 7.00001 3.93737 6.66286 3.33726 6.06275C2.73714 5.46263 2.4 4.6487 2.4 3.80001ZM0 12.6575C0 10.195 1.995 8.20001 4.4575 8.20001H6.7425C9.205 8.20001 11.2 10.195 11.2 12.6575C11.2 13.0675 10.8675 13.4 10.4575 13.4H0.7425C0.3325 13.4 0 13.0675 0 12.6575ZM12.6 8.40001V6.80001H11C10.6675 6.80001 10.4 6.53251 10.4 6.20001C10.4 5.86751 10.6675 5.60001 11 5.60001H12.6V4.00001C12.6 3.66751 12.8675 3.40001 13.2 3.40001C13.5325 3.40001 13.8 3.66751 13.8 4.00001V5.60001H15.4C15.7325 5.60001 16 5.86751 16 6.20001C16 6.53251 15.7325 6.80001 15.4 6.80001H13.8V8.40001C13.8 8.73251 13.5325 9.00001 13.2 9.00001C12.8675 9.00001 12.6 8.73251 12.6 8.40001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_3332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.8,
    fill: "white",
    transform: "translate(0 0.600006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add_person.f6a6f6c2a8bc11e024f68cacaccf89a9.svg";
export { ForwardRef as ReactComponent };